import { render, staticRenderFns } from "./SmallTitle.vue?vue&type=template&id=ee92483a&"
import script from "./SmallTitle.vue?vue&type=script&lang=js&"
export * from "./SmallTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports